import { useQuery } from '@tanstack/react-query';

import { useHookInjection } from 'domain/hooks';
import { TournamentsRepository, ITournamentsRepository } from 'domain/repositories/ITournamentsRepository';

export const TournamentsKey = 'Tournaments';

export const useCaseGetTournaments = (locationId?: string) => {
  const { fetchTournaments } = useHookInjection<ITournamentsRepository>(TournamentsRepository);

  const { data, error, isLoading } = useQuery({
    enabled: !!locationId,
    retry: 3,
    queryKey: [TournamentsKey],
    queryFn: () => fetchTournaments(locationId),
  });

  return { data: data ?? [], error, isLoading };
};
